// import React, { forwardRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../assets/logo.png";
// import Background from "../assets/hot1.jpg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBriefcase, faUser } from "@fortawesome/free-solid-svg-icons";
// import "./Sidebar.css";

// const Sidebar = forwardRef(({ isOpen }, ref) => {
//   const location = useLocation();

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   return (
//     <div
//       className={`d-flex flex-column bg-dark sidebar ${isOpen ? "open" : ""}`}
//       ref={ref}
//       style={{
//         backgroundImage: `url(${Background})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         minHeight: "100vh",
//       }}
//     >
//       <div className="sidebar-header p-3">
//         <img src={logo} alt="Logo" height="60" className="logo-image" />
//       </div>
//       <ul className="nav flex-column mt-4">
//         <li className="nav-item">
//           <Link
//             to="/admin/portfolios"
//             className={`nav-link ${isActive("/admin/portfolios") ? "active" : ""}`}
//           >
//             <FontAwesomeIcon icon={faBriefcase} /> Portfolio
//           </Link>
//         </li>
//         <li className="nav-item">
//           <Link
//             to="/admin/user"
//             className={`nav-link ${isActive("/admin/user") ? "active" : ""}`}
//           >
//             <FontAwesomeIcon icon={faUser} /> Users
//           </Link>
//         </li>
//         <li className="nav-item">
//           <Link
//             to="/admin/blacklistednames"
//             className={`nav-link ${isActive("/admin/blacklistednames") ? "active" : ""}`}
//           >
//             <FontAwesomeIcon icon={faUser} /> Black List Name
//           </Link>
//         </li>
//       </ul>
//     </div>
//   );
// });

// export default Sidebar;


// import React, { useState, useEffect, forwardRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../assets/logo.png";
// import Background from "../assets/hot1.jpg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBriefcase, faUser, faBars } from "@fortawesome/free-solid-svg-icons";
// import "./Sidebar.css";

// const Sidebar = forwardRef(({ isOpen }, ref) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(isOpen);
//   const location = useLocation();

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prevState) => !prevState);
//   };

//   // Automatically collapse the sidebar on small screens
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 768) {
//         setIsSidebarOpen(false); // Collapse on small screens
//       } else {
//         setIsSidebarOpen(true); // Expand on larger screens
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize(); // Check the initial window size

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <nav
//       className={`sidebar bg-dark ${isSidebarOpen ? "open" : ""}`}
//       ref={ref}
//       style={{ backgroundImage: `url(${Background})` }}
//     >
//       <div className="sidebar-header">
//         <img src={logo} alt="" height="60" className="logo-image" />
//         <button
//           className="sidebar-toggle-btn"
//           onClick={toggleSidebar}
//           style={{ display: window.innerWidth <= 768 ? "block" : "none" }}
//         >
//           <FontAwesomeIcon icon={faBars} />
//         </button>
//       </div>
//       <ul className="list-unstyled" style={{ marginTop: "50px" }}>
//         <li className={isActive("/admin/portfolios") ? "active" : ""}>
//           <Link to="/" className="side-nav">
//             <FontAwesomeIcon icon={faBriefcase} /> Nav Management
//           </Link>
//         </li>
//         <li className={isActive("/admin/user") ? "active" : ""}>
//           <Link to="/corporate-user" className="side-nav">
//             <FontAwesomeIcon icon={faUser} />Corporate Users
//           </Link>
//         </li>
//         <li className={isActive("/admin/blacklistednames") ? "active" : ""}>
//           <Link to="/individual-user" className="side-nav">
//             <FontAwesomeIcon icon={faUser} /> Individual Users
//           </Link>
//         </li>
//       </ul>
//     </nav>
//   );
// });

// export default Sidebar;
// import React, { useState, useEffect, forwardRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import logo from "../assets/logo.png";
// import Background from "../assets/hot1.jpg";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBriefcase, faUser, faBars } from "@fortawesome/free-solid-svg-icons";
// import "./Sidebar.css";

// const Sidebar = forwardRef(({ isOpen }, ref) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(isOpen);
//   const location = useLocation();

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prevState) => !prevState);
//   };

//   // Automatically collapse the sidebar on small screens
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 768) {
//         setIsSidebarOpen(false); // Collapse on small screens
//       } else {
//         setIsSidebarOpen(true); // Expand on larger screens
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize(); // Check the initial window size

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <nav
//       className={`sidebar bg-dark ${isSidebarOpen ? "open" : "closed"}`}
//       ref={ref}
//       style={{ backgroundImage: `url(${Background})` }}
//     >
//       <div className="sidebar-header">
//         <img src={logo} alt="" height="60" className="logo-image" />
//         <button
//           className="sidebar-toggle-btn"
//           onClick={toggleSidebar}
//           style={{ display: window.innerWidth <= 768 ? "block" : "none" }}
//         >
//           <FontAwesomeIcon icon={faBars} />
//         </button>
//       </div>
//       <ul className="list-unstyled" style={{ marginTop: "50px" }}>
//         <li className={isActive("/admin/portfolios") ? "active" : ""}>
//           <Link to="/" className="side-nav">
//             <FontAwesomeIcon icon={faBriefcase} /> Nav Management
//           </Link>
//         </li>
//         <li className={isActive("/admin/user") ? "active" : ""}>
//           <Link to="/corporate-user" className="side-nav">
//             <FontAwesomeIcon icon={faUser} /> Corporate Users
//           </Link>
//         </li>
//         <li className={isActive("/admin/blacklistednames") ? "active" : ""}>
//           <Link to="/individual-user" className="side-nav">
//             <FontAwesomeIcon icon={faUser} /> Individual Users
//           </Link>
//         </li>
//       </ul>
//     </nav>
//   );
// });

// export default Sidebar;

import React, { useState, useEffect, forwardRef } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
import Background from "../assets/hot1.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faUser, faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./Sidebar.css";

const Sidebar = forwardRef(({ isOpen }, ref) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(isOpen);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  // Automatically collapse the sidebar on small screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false); // Collapse on small screens
      } else {
        setIsSidebarOpen(true); // Expand on larger screens
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Check the initial window size

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav
      className={`sidebar bg-dark ${isSidebarOpen ? "open" : "closed"}`}
      ref={ref}
      style={{ backgroundImage: `url(${Background})` }}
    >
      <div className="sidebar-header">
        <img src={logo} alt="" height="60" className="logo-image" />
        <button
          className="sidebar-toggle-btn"
          onClick={toggleSidebar}
          style={{ display: window.innerWidth <= 768 ? "block" : "none" }}
        >
          <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} />
        </button>
      </div>
      <ul className="list-unstyled" style={{ marginTop: "50px" }}>
        <li className={isActive("/") ? "active" : ""}>
          <Link to="/" className="side-nav" style={{fontSize:"20px"}}> 
          <FontAwesomeIcon icon={faBriefcase} style={{ marginRight: '8px'}} />Nav Management
          </Link>
        </li>
        <li className={isActive("/cor-client") ? "active" : ""}>
          <Link to="/cor-client" className="side-nav"  style={{fontSize:"20px"}}>
            <FontAwesomeIcon icon={faUser}  style={{ marginRight: '8px' }}/> Corporate Clients
          </Link>
        </li>
        <li className={isActive("/ind-client") ? "active" : ""}>
          <Link to="/ind-client" className="side-nav"  style={{fontSize:"20px"}}>
            <FontAwesomeIcon icon={faUser} style={{ marginRight: '8px' }}/> Individual Clients
          </Link>
        </li>
      </ul>
    </nav>
  );
});

export default Sidebar;
